import appConfig from '@/app.config'

export default {
    data () {
        return {
            loginUrl: `${appConfig.baseUrl}3rd-party-login/`,
            isVerified: false
        }
    },

    methods: {

        tryLogin(thirdPartyname) {
            return new Promise((resolve, reject) => {
                // Open the popup window
                const popup = window.open(this.get3rdPartyUrl(thirdPartyname), '3rdloginpopup', this.popupParam())

                // Fallback when post message not works
                window.addEventListener('storage', e => {

                    if (e.key !== '3rd-login-fallback') {
                        return
                    }

                    try {
                        let payload = JSON.parse(e.newValue)

                        if (payload.action != '3rd-login') {
                            return
                        }

                        window.localStorage.setItem('3rd-login-fallback', 'remove')

                        console.info('Update token with storage change', '%ccolor:green')

                        if (payload.status && payload.status == 'success') {
                            this.isVerified = true
                            resolve(payload)
                        }

                        if (payload.status && payload.status != 'success') {
                            reject(payload)
                        }

                    } catch (e) {
                        reject(e)
                    }
                })

                window.addEventListener('message', (e) => {

                    if (typeof e.data != 'string') {
                        return
                    }

                    if (e.data.indexOf('webpack') > -1) {
                        return
                    }

                    try {
                        let payload = JSON.parse(e.data)

                        if (payload.action != '3rd-login') {
                            return
                        }

                        if (payload.status && payload.status == 'success') {
                            this.isVerified = true
                            resolve(payload)
                        }

                        if (payload.status && payload.status != 'success') {
                            reject(payload)
                        }

                        popup.postMessage('3rd-login-done', '*')

                    } catch (e) {
                        reject(e)
                    }
                })

                const interval = setInterval(() => {
                    if (popup.closed) {
                        clearInterval(interval)

                        if (!this.isVerified) {
                            this.$emit('fail')
                        }
                    }
                }, 800)
            })
        },

        tryRedirectLogin(thirdPartyname, callbackUrl) {
            var url = `${this.get3rdPartyUrl(thirdPartyname)}?redirect=${callbackUrl}`
            window.open(url, '_self')
        },

        get3rdPartyUrl(name) {
            return `${this.loginUrl}${name}`
        },

        popupParam() {

            let screenWidth = window.screen.width
            let screenHeight = window.screen.height

            let left = (screenWidth / 2) - (650 / 2)
            let top = (screenHeight / 2) - (700 / 2)

            return `scrollbars=no, resizable=no, status=no, location=no, toolbar=no,menubar=no, width=650, height=700, left=${left}, top=${top}`
        }
    }
}
